import React from 'react';
import { Eye, Zap } from 'lucide-react';
import { useAccessibility } from '../../../core/context/AccessibilityContext';

export const AccessibilityToolbar: React.FC = () => {
  const { reducedMotion, colorBlindMode, toggleReducedMotion, toggleColorBlindMode } =
    useAccessibility();

  return (
    <div
      className="flex items-center gap-1"
      role="group"
      aria-label="Accessibility options"
    >
      <ToggleButton
        active={reducedMotion}
        onClick={toggleReducedMotion}
        icon={<Zap className="w-3 h-3" />}
        label="Reduced motion"
        title={reducedMotion ? 'Reduced motion: on' : 'Reduced motion: off'}
      />
      <ToggleButton
        active={colorBlindMode}
        onClick={toggleColorBlindMode}
        icon={<Eye className="w-3 h-3" />}
        label="Color-blind mode"
        title={colorBlindMode ? 'Color-blind mode: on' : 'Color-blind mode: off'}
      />
    </div>
  );
};

interface ToggleButtonProps {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  title: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ active, onClick, icon, label, title }) => (
  <button
    onClick={onClick}
    title={title}
    aria-pressed={active}
    aria-label={label}
    className="flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-semibold transition-colors duration-150"
    style={{
      background: active ? 'rgba(99,102,241,0.18)' : 'rgba(255,255,255,0.04)',
      border: active ? '1px solid rgba(99,102,241,0.38)' : '1px solid rgba(255,255,255,0.08)',
      color: active ? '#c7d2fe' : '#52525b',
    }}
  >
    {icon}
    <span className="hidden sm:inline">{label}</span>
  </button>
);
